import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./StudentLogin.css";
import logo from "./image 6 (1).png"

const API = process.env.REACT_APP_API_URL;

function StudentLogin() {
  const navigate = useNavigate();

  const [talukas, setTalukas] = useState([]);
  const [kendras, setKendras] = useState([]);
  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState([]);
  const [standards, setStandards] = useState([]);

  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedKendra, setSelectedKendra] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");

  const [standard, setStandard] = useState(5); // or dropdown if needed

  // ✅ Load Talukas
  useEffect(() => {
    axios.get(`${API}/talukas`)
      .then(res => setTalukas(res.data))
      .catch(err => console.log(err));
  }, []);

  // ✅ Load Kendras when Taluka changes
  useEffect(() => {
    if (selectedTaluka) {
      axios.get(`${API}/kendras?taluka=${selectedTaluka}`)
        .then(res => setKendras(res.data));
    }
  }, [selectedTaluka]);

  // ✅ Load Schools
  useEffect(() => {
    if (selectedTaluka && selectedKendra) {
      axios.get(`${API}/schools`, {
        params: {
          taluka: selectedTaluka,
          kendra: selectedKendra
        }
      })
        .then(res => setSchools(res.data));
    }
  }, [selectedTaluka, selectedKendra]);

  useEffect(() => {
    if (selectedTaluka && selectedKendra && selectedSchool) {
      axios.get(`${API}/standards`, {
        params: {
          taluka: selectedTaluka,
          kendra: selectedKendra,
          school: selectedSchool
        }
      }).then(res => setStandards(res.data));
    }
  }, [selectedTaluka, selectedKendra, selectedSchool]);

  // ✅ Load Students
  useEffect(() => {
    if (selectedTaluka && selectedKendra && selectedSchool && standard) {
      axios.get(`${API}/students`, {
        params: {
          taluka: selectedTaluka,
          kendra: selectedKendra,
          school: selectedSchool,
          standard: standard
        }
      }).then(res => setStudents(res.data));
    }
  }, [selectedTaluka, selectedKendra, selectedSchool, standard]);

  // ✅ Fetch Result
  const search = () => {
    if (!selectedStudent) {
      alert("Please select student");
      return;
    }

    axios.get(`${API}/result-by-id/${selectedStudent}`)
      .then(res => {

        // ✅ Store in sessionStorage
        sessionStorage.setItem("studentId", selectedStudent);
        sessionStorage.setItem("seatNumber", res.data.candidateNumber);

        // Optional: store full result also
        sessionStorage.setItem("studentResult", JSON.stringify(res.data));

        navigate("/result", { state: res.data });
      })
      .catch(() => alert("Result not found"));
  };

  return (
    <div className="container">
      <div className="overlay">


        <div className="header">
          <img src={logo} />
          <h3>सातारा जिल्हा परिषद, सातारा</h3>
          <p className="subtitle">
            सातारा जिल्हा प्रज्ञाशोध परीक्षा, सन 2025-2026
          </p>
        </div>

        <div className="login-box">
          <h2>Student Login</h2>
          <div className="dropdown">
            {/* Taluka */}
            <select onChange={(e) => setSelectedTaluka(e.target.value)}>
              <option>Select Taluka</option>
              {talukas.map((t, i) => (
                <option key={i} value={t}>{t}</option>
              ))}
            </select>

            {/* Kendra */}
            <select onChange={(e) => setSelectedKendra(e.target.value)}>
              <option>Select Pariksha Kendra</option>
              {kendras.map((k, i) => (
                <option key={i} value={k}>{k}</option>
              ))}
            </select>

            {/* School */}
            <select onChange={(e) => setSelectedSchool(e.target.value)}>
              <option>Select School</option>
              {schools.map((s, i) => (
                <option key={i} value={s}>{s}</option>
              ))}
            </select>

            {/* Standard */}
            <select onChange={(e) => setStandard(e.target.value)}>
              <option>Select Standard</option>
              {standards.map((s, i) => (
                <option key={i} value={s}>{s}</option>
              ))}
            </select>

            {/* Student */}
            <select onChange={(e) => setSelectedStudent(e.target.value)}>
              <option>Select Student</option>
              {students.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.candidateName} ({s.candidateNumber})
                </option>
              ))}
            </select>
          </div>

          <button onClick={search}>Check Result</button>
        </div>

      </div>
    </div>
  );
}

export default StudentLogin;